import React, { FC, useMemo } from 'react';
import { FieldConfig, FieldProps } from 'formik';
import {
  FormControl,
  FormLabel,
  FormControlLabel,
  Checkbox,
  TextFieldProps,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

type Props = TextFieldProps & FieldConfig & FieldProps;

const CheckboxOneField: FC<Props> = ({ field, ...rest }) => {
  const { t } = useTranslation();
  const error = useMemo(() => {
    const err = rest.form.errors[field.name];

    return err ? String(err) : '';
  }, [field, rest.form.errors]);

  return (
    <FormControl component="fieldset" error={!!error}>
      <FormControlLabel
        name={rest?.name}
        control={<Checkbox checked={field?.value == true ? true : false} color="primary" />}
        label={rest?.label}
        {...field}
      />
    </FormControl>
  );
};
export default CheckboxOneField;
